var React = require('react');

function SteeringWheel (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M432,256a185.53,185.53,0,0,1-2.76,32H328l-48,64v85.24a186.89,186.89,0,0,1-64,0V352l-48-64H66.76a186.89,186.89,0,0,1,0-64h94.13A63.69,63.69,0,0,1,216,192h64a63.72,63.72,0,0,1,55.12,32h94.11A185.54,185.54,0,0,1,432,256Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,72A184,184,0,1,1,64,256,184,184,0,0,1,248,72m0-64C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8Z","className":"fa-primary","key":2})]);
}

SteeringWheel.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = SteeringWheel;

SteeringWheel.default = SteeringWheel;
